import { BaseModel } from "../base-model";
import { IPersonDocumentModel } from "./person-document.model";

export interface IPersonModel {
	AddressAGoogleX?: number;
	AddressAGoogleY?: number;

	AltAddressAGoogleX?: number;
	AltAddressAGoogleY?: number;

	Alt2AddressAGoogleX?: number;
	Alt2AddressAGoogleY?: number;

	AddressA?: string;
	AddressB?: string;
	AddressTitle?: string;
	AddressType?: string;
	Alt2AddressA?: string;
	Alt2AddressB?: string;
	Alt2AddressType?: string;
	Alt2BoxNr?: string;
	Alt2CityName?: string;
	Alt2CityPostcode?: string;
	Alt2Country?: string;
	Alt2CountryCode?: string;
	Alt2Province?: string;
	AltAddress?: string;
	AltAddressA?: string;
	AltAddressB?: string;
	AltAddressType?: string;
	AltBoxNr?: string;
	AltCityId?: number;
	AltCityName?: string;
	AltCityPostcode?: string;
	AltCountry?: string;
	AltCountryCode?: string;
	AltFax?: string;
	AltPhone?: string;
	AltProvince?: string;
	AvailableAfterLoan?: number;
	AvailableMoney?: number;
	BankA?: string;
	BankB?: string;
	BICA?: string;
	BICB?: string;
	BirthDay?: string;
	BirthPlace?: string;
	BIV?: string;
	BoxNr?: string;
	Budget?: number;
	BusinessReceiverId?: number;
	BusinessSenderId?: number;
	CategoriesDesc?: string;
	CheckA?: true;
	CheckB?: true;
	CheckC?: true;
	CheckD?: true;
	CityId?: number;
	CityName?: string;
	CityPostcode?: string;
	Comment?: string;
	CompanyId?: number;
	CompanyName?: string;
	CountryCode?: string;
	CountryDesc?: string;
	CountryId?: number;
	CountryId2?: number;
	CountryId3?: number;
	CustomStr1?: string;
	CustomStr2?: string;
	CustomStr3?: string;
	CustomStr4?: string;
	CustomStr5?: string;
	CustomStr6?: string;
	DepartmentId?: number;
	Documents?: IPersonDocumentModel[];
	Email?: string;
	Email2?: string;
	Email3?: string;
	EnteredDate?: string;
	EnteredId?: number;
	EntryId?: string;
	ExternalId?: string;
	FacebookId?: string;
	FacebookInfo?: string;
	Fax?: string;
	FirstBuy?: true;
	FirstName?: string;
	Function?: string;
	HasPic?: true;
	Id?: number;
	IDCardNumber?: string;
	IsDeleted?: true;
	Language?: number;
	LastChange?: string;
	LastChangedBy?: number;
	LetterTitle?: string;
	LinkedinId?: string;
	LinkedInInfo?: string;
	LinkedinToLink?: string;
	LoanLength?: number;
	LoanPercent?: number;
	ManagerId?: number;
	MaritalStatusId?: number;
	MobilePhone?: string;
	ModifiedDate?: string;
	MoneyLent?: number;
	MontlyPayments?: number;
	Name?: string;
	Nationality?: string;
	NationalRegister?: string;
	NeverSendMail?: true;
	NoMailings?: true;
	NrPersons?: string;
	OrigId?: number;
	OriginContactId?: number;
	OwnPropertyValue?: number;
	PartnerBirthDay?: string;
	PartnerFirstName?: string;
	PartnerLastName?: string;
	Password?: string;
	PhoneBusiness?: string;
	PhoneComment1?: string;
	PhoneComment10?: string;
	PhoneComment2?: string;
	PhoneComment3?: string;
	PhoneComment4?: string;
	PhoneComment5?: string;
	PhoneComment6?: string;
	PhoneComment7?: string;
	PhoneComment8?: string;
	PhoneComment9?: string;
	PhoneDesc1?: string;
	PhoneDesc10?: string;
	PhoneDesc2?: string;
	PhoneDesc3?: string;
	PhoneDesc4?: string;
	PhoneDesc5?: string;
	PhoneDesc6?: string;
	PhoneDesc7?: string;
	PhoneDesc8?: string;
	PhoneDesc9?: string;
	PhoneNumber1?: string;
	PhoneNumber10?: string;
	PhoneNumber2?: string;
	PhoneNumber3?: string;
	PhoneNumber4?: string;
	PhoneNumber5?: string;
	PhoneNumber6?: string;
	PhoneNumber7?: string;
	PhoneNumber8?: string;
	PhoneNumber9?: string;
	PhonePrivate?: string;
	PreferredConfirmationId?: number;
	PreferredMediaId?: number;
	Profession?: string;
	ProfessionC21?: number;
	Province?: string;
	RC?: string;
	Reference?: string;
	SendEmail2?: true;
	SendEmail3?: true;
	ShadowCompanyId?: number;
	SiteId?: number;
	StatusId?: number;
	TwoInComes?: true;
	VAT?: string;
	WebModified?: true;
	Website?: string;
	NormalizePhoneIndexes?: string;
	PictureUrl?: string;
	PictureUrlDisplay?: string;
	ViewType?: number;
}

export class PersonModel extends BaseModel<IPersonModel>
	implements IPersonModel {
	AddressAGoogleX?: number;
	AddressAGoogleY?: number;

	AltAddressAGoogleX?: number;
	AltAddressAGoogleY?: number;

	Alt2AddressAGoogleX?: number;
	Alt2AddressAGoogleY?: number;

	AddressA?: string;
	AddressB?: string;
	AddressTitle?: string;
	AddressType?: string;
	Alt2AddressA?: string;
	Alt2AddressB?: string;
	Alt2AddressType?: string;
	Alt2BoxNr?: string;
	Alt2CityName?: string;
	Alt2CityPostcode?: string;
	Alt2Country?: string;
	Alt2CountryCode?: string;
	Alt2Province?: string;
	AltAddress?: string;
	AltAddressA?: string;
	AltAddressB?: string;
	AltAddressType?: string;
	AltBoxNr?: string;
	AltCityId?: number;
	AltCityName?: string;
	AltCityPostcode?: string;
	AltCountry?: string;
	AltCountryCode?: string;
	AltFax?: string;
	AltPhone?: string;
	AltProvince?: string;
	AvailableAfterLoan?: number;
	AvailableMoney?: number;
	BankA?: string;
	BankB?: string;
	BICA?: string;
	BICB?: string;
	BirthDay?: string;
	BirthPlace?: string;
	BIV?: string;
	BoxNr?: string;
	Budget?: number;
	BusinessReceiverId?: number;
	BusinessSenderId?: number;
	CategoriesDesc?: string;
	CardType?: number;
	CardValidFrom?: string;
	CardValidUntil?: string;
	CheckA?: true;
	CheckB?: true;
	CheckC?: true;
	CheckD?: true;
	ChipNumber?: string;
	CityId?: number;
	CityName?: string;
	CityPostcode?: string;
	Comment?: string;
	CompanyId?: number;
	CompanyName?: string;
	CountryCode?: string;
	CountryDesc?: string;
	CountryId?: number;
	CountryId2?: number;
	CountryId3?: number;

	CountryName?: string;
	CountryName2?: string;
	CountryName3?: string;
	
	IsCommonCountry?: boolean;
	IsCommonCountry2?: boolean;
	IsCommonCountry3?: boolean;

	CustomStr1?: string;
	CustomStr2?: string;
	CustomStr3?: string;
	CustomStr4?: string;
	CustomStr5?: string;
	CustomStr6?: string;
	DepartmentId?: number;
	Documents?: IPersonDocumentModel[];
	Email?: string;
	Email2?: string;
	Email3?: string;
	EnteredDate?: string;
	EnteredId?: number;
	EntryId?: string;
	ExternalId?: string;
	FacebookId?: string;
	FacebookInfo?: string;
	Fax?: string;
	FirstBuy?: true;
	FirstName?: string;
	Function?: string;
	Gender?: number;
	HasPic?: true;
	Id?: number;
	IDCardNumber?: string;
	IsDeleted?: true;
	Language?: number;
	LastChange?: string;
	LastChangedBy?: number;
	LetterTitle?: string;
	LinkedinId?: string;
	LinkedInInfo?: string;
	LinkedinToLink?: string;
	LoanLength?: number;
	LoanPercent?: number;
	ManagerId?: number;
	MaritalStatusId?: number;
	MiddleName?: string
	MobilePhone?: string;
	ModifiedDate?: string;
	MoneyLent?: number;
	MontlyPayments?: number;
	Name?: string;
	NationalRegister?: string;
	Nationality?: string;
	NeverSendMail?: true;
	NobleCondition?: string;
	NoMailings?: true;
	NrPersons?: string;
	OrigId?: number;
	OriginContactId?: number;
	OwnPropertyValue?: number;
	PartnerBirthDay?: string;
	PartnerFirstName?: string;
	PartnerLastName?: string;
	Password?: string;
	PhoneBusiness?: string;
	PhoneComment1?: string;
	PhoneComment10?: string;
	PhoneComment2?: string;
	PhoneComment3?: string;
	PhoneComment4?: string;
	PhoneComment5?: string;
	PhoneComment6?: string;
	PhoneComment7?: string;
	PhoneComment8?: string;
	PhoneComment9?: string;
	PhoneDesc1?: string;
	PhoneDesc10?: string;
	PhoneDesc2?: string;
	PhoneDesc3?: string;
	PhoneDesc4?: string;
	PhoneDesc5?: string;
	PhoneDesc6?: string;
	PhoneDesc7?: string;
	PhoneDesc8?: string;
	PhoneDesc9?: string;
	PhoneNumber1?: string;
	PhoneNumber10?: string;
	PhoneNumber2?: string;
	PhoneNumber3?: string;
	PhoneNumber4?: string;
	PhoneNumber5?: string;
	PhoneNumber6?: string;
	PhoneNumber7?: string;
	PhoneNumber8?: string;
	PhoneNumber9?: string;
	PhonePrivate?: string;
	PlaceOfIssue?: string;
	PreferredConfirmationId?: number;
	PreferredMediaId?: number;
	Profession?: string;
	ProfessionC21?: number;
	Province?: string;
	RC?: string;
	Reference?: string;
	SendEmail2?: true;
	SendEmail3?: true;
	ShadowCompanyId?: number;
	SiteId?: number;
	SpecialStatus?: number;
	StatusId?: number;
	TwoInComes?: true;
	VAT?: string;
	WebModified?: true;
	Website?: string;
	NormalizePhoneIndexes?: string;
	PictureUrl?: string;
	PictureUrlDisplay?: string;
	ViewType?: number;

    CheckingConfictData?: string;
	/**
	 *
	 */
	constructor(option?: IPersonModel) {
		super(option);

		this.AddressAGoogleX = null;
		this.AddressAGoogleY = null;

		this.AltAddressAGoogleX = null;
		this.AltAddressAGoogleY = null;

		this.Alt2AddressAGoogleX = null;
		this.Alt2AddressAGoogleY = null;

		this.AddressA = null;
		this.AddressB = null;
		this.AddressTitle = null;
		this.AddressType = null;
		this.Alt2AddressA = null;
		this.Alt2AddressB = null;
		this.Alt2AddressType = null;
		this.Alt2BoxNr = null;
		this.Alt2CityName = null;
		this.Alt2CityPostcode = null;
		this.Alt2Country = null;
		this.Alt2CountryCode = null;
		this.Alt2Province = null;
		this.AltAddress = null;
		this.AltAddressA = null;
		this.AltAddressB = null;
		this.AltAddressType = null;
		this.AltBoxNr = null;
		this.AltCityId = null;
		this.AltCityName = null;
		this.AltCityPostcode = null;
		this.AltCountry = null;
		this.AltCountryCode = null;
		this.AltFax = null;
		this.AltPhone = null;
		this.AltProvince = null;
		this.AvailableAfterLoan = null;
		this.AvailableMoney = null;
		this.BankA = null;
		this.BankB = null;
		this.BICA = null;
		this.BICB = null;
		this.BirthDay = null;
		this.BirthPlace = null;
		this.BIV = null;
		this.BoxNr = null;
		this.Budget = null;
		this.BusinessReceiverId = null;
		this.BusinessSenderId = null;
		this.CategoriesDesc = null;
		this.CardType = null;
		this.CardValidFrom = null;
		this.CardValidUntil = null;
		this.CheckA = null;
		this.CheckB = null;
		this.CheckC = null;
		this.CheckD = null;
		this.ChipNumber = null;
		this.CityId = null;
		this.CityName = null;
		this.CityPostcode = null;
		this.Comment = null;
		this.CompanyId = null;
		this.CompanyName = null;
		this.CountryCode = null;
		this.CountryDesc = null;
		this.CountryId = null;
		this.CountryId2 = null;
		this.CountryId3 = null;
		this.CountryName = null;
		this.CountryName2 = null;
		this.CountryName3 = null;
		this.CustomStr1 = null;
		this.CustomStr2 = null;
		this.CustomStr3 = null;
		this.CustomStr4 = null;
		this.CustomStr5 = null;
		this.CustomStr6 = null;
		this.DepartmentId = null;
		this.Documents = [];
		this.Email = null;
		this.Email2 = null;
		this.Email3 = null;
		this.EnteredDate = null;
		this.EnteredId = null;
		this.EntryId = null;
		this.ExternalId = null;
		this.FacebookId = null;
		this.FacebookInfo = null;
		this.Fax = null;
		this.FirstBuy = null;
		this.FirstName = null;
		this.Function = null;
		this.Gender = null;
		this.HasPic = null;
		this.Id = null;
		this.IDCardNumber = null;
		this.IsDeleted = null;
		this.Language = null;
		this.LastChange = null;
		this.LastChangedBy = null;
		this.LetterTitle = null;
		this.LinkedinId = null;
		this.LinkedInInfo = null;
		this.LinkedinToLink = null;
		this.LoanLength = null;
		this.LoanPercent = null;
		this.ManagerId = null;
		this.MaritalStatusId = null;
		this.MiddleName = null;
		this.MobilePhone = null;
		this.ModifiedDate = null;
		this.MoneyLent = null;
		this.MontlyPayments = null;
		this.Name = null;
		this.Nationality = null;
		this.NationalRegister = null;
		this.NeverSendMail = null;
		this.NobleCondition = null;
		this.NoMailings = null;
		this.NrPersons = null;
		this.OrigId = null;
		this.OriginContactId = null;
		this.OwnPropertyValue = null;
		this.PartnerBirthDay = null;
		this.PartnerFirstName = null;
		this.PartnerLastName = null;
		this.Password = null;
		this.PhoneBusiness = null;
		this.PhoneComment1 = null;
		this.PhoneComment10 = null;
		this.PhoneComment2 = null;
		this.PhoneComment3 = null;
		this.PhoneComment4 = null;
		this.PhoneComment5 = null;
		this.PhoneComment6 = null;
		this.PhoneComment7 = null;
		this.PhoneComment8 = null;
		this.PhoneComment9 = null;
		this.PhoneDesc1 = null;
		this.PhoneDesc10 = null;
		this.PhoneDesc2 = null;
		this.PhoneDesc3 = null;
		this.PhoneDesc4 = null;
		this.PhoneDesc5 = null;
		this.PhoneDesc6 = null;
		this.PhoneDesc7 = null;
		this.PhoneDesc8 = null;
		this.PhoneDesc9 = null;
		this.PhoneNumber1 = null;
		this.PhoneNumber10 = null;
		this.PhoneNumber2 = null;
		this.PhoneNumber3 = null;
		this.PhoneNumber4 = null;
		this.PhoneNumber5 = null;
		this.PhoneNumber6 = null;
		this.PhoneNumber7 = null;
		this.PhoneNumber8 = null;
		this.PhoneNumber9 = null;
		this.PhonePrivate = null;
		this.PlaceOfIssue = null;
		this.PreferredConfirmationId = null;
		this.PreferredMediaId = null;
		this.Profession = null;
		this.ProfessionC21 = null;
		this.Province = null;
		this.RC = null;
		this.Reference = null;
		this.SendEmail2 = null;
		this.SendEmail3 = null;
		this.ShadowCompanyId = null;
		this.SiteId = null;
		this.SpecialStatus = null;
		this.StatusId = null;
		this.TwoInComes = null;
		this.VAT = null;
		this.WebModified = null;
		this.Website = null;
		this.NormalizePhoneIndexes = '';

	}
}
